module.exports = __webpack_public_path__ + "img/dead_link_badge.ddc5de33.svg";